const pluralize = (term: string, source: number | Array<any>): string => {
  const value = typeof source === 'number' ? source : source.length
  return `${term}${value > 1 ? 's' : ''}`
}

export default pluralize
